import { render, staticRenderFns } from "./pengajian.vue?vue&type=template&id=a0bd8718"
import script from "./pengajian.vue?vue&type=script&lang=js"
export * from "./pengajian.vue?vue&type=script&lang=js"
import style0 from "./pengajian.vue?vue&type=style&index=0&id=a0bd8718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports